
import Vue, { PropType } from 'vue';
import Heading from '@/components/Heading/index.vue';
import Notification from '@/components/Notification/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import { NotificationProps } from '../../config/types';
import { Wrapper, Container } from './styles';

export default Vue.extend({
  name: 'NotificationCenter',
  components: {
    Container,
    Heading,
    Notification,
    ResultMessage,
    Wrapper,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    handleFunction: {
      type: Function,
    },
    notifications: {
      type: Array as PropType<Array<NotificationProps>>,
      default: [],
    },
    loadingViewed: {
      type: Boolean,
      default: false,
    },
    loadingNotViewed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    execute() {
      if (this.handleFunction) this.handleFunction();
    },
    genarate() {
      const { crypto } = window;
      const array = new Uint32Array(1);
      const randomCryptNumber = crypto.getRandomValues(array);
      return String(Date.now().toString(32) + randomCryptNumber.toString()).replace(/[^0-9]/g, '');
    },
    notAccept() {
      console.log('not accept');
    },
    changeNotAcept() {
      this.$emit('changeNotAcept');
    },
  },
});
